<!-- One context is not a choice: this is the label the navbar has always shown. -->
<div class="navbar-school-brand" *ngIf="!hasChoice; else schoolSwitcher">
  <span class="material-symbols-outlined navbar-school-brand__icon" aria-hidden="true">villa</span>
  <span class="navbar-school-brand__name">{{ schoolName }}</span>
</div>

<ng-template #schoolSwitcher>
  <div ngbDropdown class="navbar-school-switcher">
    <a class="navbar-school-brand navbar-school-switcher__toggle" ngbDropdownToggle
       id="navbarSchoolSwitcher" href="javascript:void(0)"
       aria-haspopup="true" aria-expanded="false">
      <span class="material-symbols-outlined navbar-school-brand__icon" aria-hidden="true">villa</span>
      <span class="navbar-school-brand__name">{{ schoolName }}</span>
      <span class="navbar-school-switcher__curriculum" *ngIf="activeCurriculum">{{ activeCurriculum }}</span>
      <span class="material-symbols-outlined navbar-school-switcher__chevron" aria-hidden="true">expand_more</span>
    </a>
    <div ngbDropdownMenu aria-labelledby="navbarSchoolSwitcher" class="dropdown-menu navbar-school-switcher__menu">
      <a ngbDropdownItem *ngFor="let context of contexts; trackBy: trackByContext"
         href="javascript:void(0)"
         class="navbar-school-switcher__item"
         [class.active]="isActive(context)"
         [class.disabled]="isSwitching"
         (click)="switchTo(context)">
        <span class="navbar-school-switcher__item-name">{{ context.schoolName }}</span>
        <!-- The two entries of a hybrid school share a name; the curriculum is what separates them. -->
        <span class="navbar-school-switcher__curriculum" *ngIf="context.curriculum">{{ context.curriculum }}</span>
      </a>
    </div>
  </div>
</ng-template>
